export function historyWithoutOutboundEmail<T extends { stage: string }>(entries: T[]): T[] {
  return entries.filter((e) => e.stage !== 'outbound_email');
}
